//
// Collection names
//
export const ORGANIZATIONS_COLLECTION = 'organizations';
export const ORGANIZATION_USERS_COLLECTION = 'organizationUsers';
